module.exports = __webpack_public_path__ + "static/media/Error404.1e4d570c.png";